import * as React from 'react';
import { Dots } from './Dots';
import { TooltipAction } from './TooltipAction';
import { TooltipMenu } from './TooltipMenu';
import { TooltipMobileMenu, TooltipMobileAction } from './TooltipMobileMenu';
import './Tooltip.scss';

const classnames = require('classnames');

export interface TooltipProps {
  open: boolean;
  hideMenu: () => void;
  openMenu: () => void;
  className?: string;
}

export class Tooltip extends React.Component<TooltipProps, {}> {
  static Action = TooltipAction;
  static MobileMenu = TooltipMobileMenu;
  static MobileAction = TooltipMobileAction;

  openMenu = (e) => {
    e.stopPropagation();
    this.props.openMenu();
  };

  handleClickOutside = () => {
    this.props.hideMenu();
  };

  render() {
    const { open, children } = this.props;

    let menu = null;

    if (open) {
      menu = <TooltipMenu>{children}</TooltipMenu>;
    }

    const className = classnames('noble-tooltip-btn', this.props.className);

    return (
      <div className={className}>
        <div role='button' onClick={this.openMenu} id='actions-btn'>
          <Dots />
        </div>
        {menu}
      </div>
    );
  }
}
